module.exports = __webpack_public_path__ + "static/media/BDBT08.f1388e28.jpg";